import React, { useEffect, useState } from 'react';
import { Button, Row, Col, message } from 'antd';
import { motion, useScroll, useTransform } from 'framer-motion';
import axios from 'axios'; // Import axios
import './HeroSection.css';
import Hero from '../assets/Hero.png';
import GoogleReviewCard from './GoogleReviewCard';

const HeroSection = () => {
  const { scrollYProgress } = useScroll();
  const [firstReview, setFirstReview] = useState(null);
  const [loadingReview, setLoadingReview] = useState(true);

  // Fetch the first review when the component mounts
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/home/Testimonials`)
      .then(response => {
        if (response.data.success && response.data.content.testimonials && response.data.content.testimonials.length > 0) {
          setFirstReview(response.data.content.testimonials[0]); // Set only the first review
        } else {
          message.error("Failed to load a review for the hero section.");
        }
      })
      .catch(() => {
        message.error("Error fetching review for the hero section.");
      })
      .finally(() => setLoadingReview(false));
  }, []);

  // More pronounced parallax effect for the background image
  const backgroundY = useTransform(scrollYProgress, [0, 1], ['0%', '300%']);

  // Animation for the title
  const titleVariants = {
    hidden: { opacity: 0, y: 70 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeInOut" } },
  };

  // Animation for the subtitle
  const subtitleVariants = {
    hidden: { opacity: 0, x: -70 },
    visible: { opacity: 1, x: 0, transition: { duration: 1, ease: "easeInOut", delay: 0.3 } },
  };

  // Animation for box1
  const box1Variants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeInOut" } },
  };

  return (
    <div className="hero-section" style={{ backgroundImage: `url(${Hero})` }}>
      <motion.div
        className="hero-overlay"
        style={{
          y: backgroundY,
        }}
      >
        <div className="hero-content">
          <Row justify="center">
            <Col xs={24} md={20} lg={16}>
              <motion.div
                className="box1"
                variants={box1Variants}
                initial="hidden"
                animate="visible"
              >
                <p className="hero-services">Our Popular Services</p>
                <div className="hero-tags">
                  <span>Birthday Bash | School Tour | Poolside Seating</span>
                </div>
              </motion.div>
            </Col>
          </Row>

          <Row justify="end">
            <Col xs={24} sm={24} md={20} lg={10}>
              <div className="box2">
                <motion.h1
                  className="hero-title"
                  variants={titleVariants}
                  initial="hidden"
                  animate="visible"
                >
                  Welcome to <br />
                  <span>Kiddtopia</span>
                </motion.h1>
                <motion.p
                  className="hero-subtitle"
                  variants={subtitleVariants}
                  initial="hidden"
                  animate="visible"
                >
                  "Service to sab dete hain par hum yaadein banatein hain"
                </motion.p>
                <Button className="hero-button btn">
                  Book Now
                </Button>
                {!loadingReview && firstReview && (
                  <GoogleReviewCard
                    name={firstReview.name}
                    rating={firstReview.stars}
                    review={firstReview.paragraph}
                    className="hero-review-card"
                    hideOnSmallScreen="yes"
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </motion.div>
    </div>
  );
};

export default HeroSection;